import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getQaQuestion = (questionId) =>
  httpClient.get(apis.getQaQuestion({ questionId }), null, { ignore: true });
export const doThumb = (payload) =>
  httpClient.post(apis.QA_QUESTION_DO_THUMB, payload, { ignore: true });
export const toFollow = (payload) =>
  httpClient.post(apis.QA_QUESTION_TO_FOLLOW, payload, { ignore: true });
export const toUnFollow = (payload) =>
  httpClient.post(apis.QA_QUESTION_TO_UNFOLLOW, payload, { ignore: true });
export const submitComment = (payload) =>
  httpClient.post(apis.QA_QUESTION_ANSWER_COMMENT, payload, { ignore: true });
export const doAccept = (payload) =>
  httpClient.post(apis.QA_QUESTION_ANSWER_ACCEPT, payload, { ignore: true });
export const feedback = (payload) =>
  httpClient.post(apis.QA_QUESTION_ANSWER_FEEDBACK, payload, { ignore: true });
export const setQuestionUnread = (payload) =>
  httpClient.post(apis.QA_QUESTION_TO_UNREAD, payload, { ignore: true });
export const getQuestionReferralInQuestion = (questionId) =>
  httpClient.get(apis.getQuestionReferralInQuestion({ questionId }), { ignore: true });
export const getQuestionSharedNoteInQuestion = (questionId) =>
  httpClient.get(apis.getQuestionSharedNoteInQuestion({ questionId }), { ignore: true });
export const postQaGrade = (payload) =>
  httpClient.post(apis.POST_QA_GRADE, payload, { ignore: true });
